<template>
	<Container>
		<div class="content">
			<div class="list">
				<div class="item" :class='{appItem:isApp}' v-for='item in list' @click='go(item)'>
					<img class='img' :src="item.ExtDataValue" alt="">
					<div class='title'>{{item.DataLabel}}</div>
				</div>
			</div>
		</div>
	</Container>
</template>

<script>
	import {baseUrl} from '@/config/env'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				list:[],
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
			isApp(){
				return navigator.userAgent.indexOf('com.doterra.app') != -1
			} 
		},
		methods: {
			...mapActions([
				'getGuidesAction',
			]),
			async initData(){
				let isSmall = document.body.clientWidth < 768
				let response = await this.getGuidesAction(this.isApp?'DT_App_NewCustomerGuid':'DT_WebSite_NewCustomerGuid')
				this.list = response
				this.appAction('setTitle',{title:'精油如何买'})
			},
			appAction(action,params) {
				if (this.isApp) {
				    let data = JSON.stringify({params,action})
				    window.postMessage(data)
				}
			},
			go(item){
				if (item.DataValue.indexOf('app://GeneralStatic') == 0 && !this.isApp) {
					location = item.DataValue.replace('app://GeneralStatic',`${baseUrl}/client/index.html#/show/guide/detail`)
				} else {
					location = item.DataValue
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.content {
		min-height:100%;
		display:flex;
		align-items: center;
	}
	.list {
		padding: 3vw 10vw;
		display:flex;
		flex-direction: row;
		flex-wrap: wrap;
		// gap:max(2vw,20px);
		justify-content: center;
		.item {
			position:relative;
			width:35vw;
			height:14vw;
			cursor: pointer;
			border-radius: 10px;
			overflow:hidden;
			margin:20px;
			.img {
				width:100%;
				height:100%;
				object-fit: cover;
			}
			.title {
				position:absolute;
				width:100%;
				bottom:10px;
				text-align:center;
				color:white;
				font-size: 16px;
				font-weight: bold;
				text-shadow: 3px 5px 6px rgba(0,0,0,0.2);
			}
		}
		.appItem {
			box-shadow:4px 3px 10px 0 rgba(0,0,0,0.1);
		}
	}
	@media (max-width: 768px){
		.content {
			display:block;
		}
		.list {
			padding:0;
			padding-top: 2.5vw;
			flex-direction: column;
			flex-wrap: wrap;
			gap:0;
			.item {
				width:95vw;
				height:22vh;
				text-align: center;
				margin:0 2.5vw;
				margin-bottom: 2.5vw;
			}
		}
	}
	
</style>
